// DB product names arrive ALL-CAPS ("COK.MLIJECNA USKRS 80 G DORINA"). Title-case
// the first letter of each whitespace token for a calmer, less shouty label.
export function toTitleCase(str) {
  if (!str) return ''
  return String(str)
    .toLowerCase()
    .split(/(\s+)/)
    .map((tok) => tok.replace(/\p{L}/u, (c) => c.toUpperCase()))
    .join('')
}

// Measurement units we recognise after a number, so we can lowercase them
// ("80 G" -> "80 g") and keep them lowercase through title-casing.
const UNIT = /^(kg|g|gr|mg|ml|cl|dl|l|kom|kos)$/i

// Title-case words but keep recognised units and the pack multiplier "x" lowercase.
function titleCaseTokens(str) {
  return str
    .toLowerCase()
    .split(/(\s+)/)
    .map((tok) => {
      const lower = tok.toLowerCase()
      if (lower === 'x' || UNIT.test(lower)) return lower
      return lower.replace(/\p{L}/u, (c) => c.toUpperCase())
    })
    .join('')
}

// Clean a raw feed product name into a calmer display label:
//   "FRISKIES MH ZA MAČKE GOVEDINA 12*85G" -> "Friskies Mh Za Mačke Govedina 12 x 85 g"
//   "VEGETA 250 G (16) PODRAVKA"            -> "Vegeta 250 g Podravka"
// Conservative: only touches pack notation, known units, and bare "(N)" counts.
export function cleanProductName(str) {
  if (!str) return ''
  let s = String(str).trim()

  // Pack multiplier: "12*85G", "12 x 85 g", "12×85" -> "12 x 85 g"
  s = s.replace(
    /(\d+)\s*[*x×]\s*(\d+)\s*(kg|g|gr|mg|ml|cl|dl|l)?/gi,
    (_m, a, b, unit) => (unit ? `${a} x ${b} ${unit.toLowerCase()}` : `${a} x ${b}`)
  )

  // Unit glued to or following a number: "80G", "250 ML" -> "80 g", "250 ml"
  s = s.replace(
    /(\d+(?:[.,]\d+)?)\s*(kg|g|gr|mg|ml|cl|dl|l|kom|kos)\b/gi,
    (_m, num, unit) => `${num} ${unit.toLowerCase()}`
  )

  // Drop a bare parenthetical count like "(16)" — meaningless to shoppers.
  s = s.replace(/\s*\(\d+\)/g, '')

  // Collapse runs of whitespace.
  s = s.replace(/\s{2,}/g, ' ').trim()

  return titleCaseTokens(s)
}
